import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
// import { HashMap } from '@jsverse/transloco/lib/utils/type.utils';
import { filter, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private snackBar = inject(MatSnackBar);
  private translator = inject(TranslocoService);
  private router = inject(Router);

  private curNotification: MatSnackBarRef<unknown> | null = null;

  showNotice(message: string, params?: Record<string, unknown>) {
    this.curNotification = this.snackBar.open(this.getTranslatedMessage(message, params), 'OK', {
      duration: 10000,
      panelClass: 'snack-bar-notice',
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
    this.setupDismissOnNavigation();
  }

  showError(message: string, params?: Record<string, unknown>) {
    this.curNotification = this.snackBar.open(this.getTranslatedMessage(message, params), 'OK', {
      duration: 10000,
      panelClass: 'snack-bar-error',
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
    this.setupDismissOnNavigation();
  }

  showSuccess(message: string, params?: Record<string, unknown>) {
    this.curNotification = this.snackBar.open(this.getTranslatedMessage(message, params), 'OK', {
      duration: 10000,
      panelClass: 'snack-bar-success',
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
    this.setupDismissOnNavigation();
  }

  savedMessage() {
    this.showSuccess(_('snackbar.success.saved'));
  }

  removedMessage() {
    this.showSuccess(_('snackbar.success.removed'));
  }

  private getTranslatedMessage(messageKey: string, params?: Record<string, unknown>) {
    return this.translator.translate(messageKey, params);
  }

  private setupDismissOnNavigation(duration = 750) {
    setTimeout(() => {
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          take(1),
        )
        .subscribe(() => {
          this.curNotification?.dismiss();
        });
    }, duration);
  }
}
